<template>
  <v-card-text
    class="px-1"
  >
    <v-form
      ref="form"
      v-model="valid"
      class="multi-col-validation"
    >
      <v-row class="d-flex justify-space-between align-center">
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            label="Email:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            label="Celular:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            label="CPF:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            label="RG:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            label="Órgão Emissor:"
            outlined
            dense
            disabled
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            label="Data de Nascimento:"
            outlined
            dense
            disabled
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="d-flex justify-space-between align-center">
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            label="CEP:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="2"
        >
          <v-select
            label="Estado:"
            outlined
            dense
            disabled
            :items="estados"
          >
          </v-select>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-select
            label="Cidade:"
            outlined
            dense
            disabled
            :items="estados"
          >
          </v-select>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            label="Bairro:"
            outlined
            dense
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            label="Rua:"
            outlined
            dense
            disabled
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            label="Número:"
            outlined
            dense
            disabled
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            label="Complemento:"
            outlined
            dense
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  mdiDelete,
} from '@mdi/js'

export default {
  components: {
  },

  setup() {
    const loading = ref(false)
    const valid = ref(false)
    const form = ref(null)

    const resetForm = () => {
      form.value.reset()
    }

    const estados = [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO',
    ]

    return {
      estados,
      loading,
      valid,
      form,
      resetForm,
      icons: {
        mdiDelete,
      },
    }
  },
}
</script>
